import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { API_URL } from "../../shared/constant";
import Loader from "../../shared/loader";
import axios from "axios";
import Swal from "sweetalert2";

const Subscription = () => {
  const [planData, setPlanData] = useState([]);
  const [loading, setLoading] = useState(true);

  const getPlans = () => {
    axios.post(API_URL.PLAN_LIST, {}).then(
      (res) => {
        if (res.data.status === 1) {
          setPlanData(res.data.data);
        }
        setLoading(false);
      },
      (error) => {
        console.log(error.response?.data);
        setLoading(false);
        toast.error(error.response?.data?.message || "Something went wrong", {
          autoClose: 3000,
        });
      }
    );
  };

  const deletePlan = (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this Plan",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(API_URL.PLAN_DELETE, { id: row.id }).then(
          (res) => {
            if (res.data.status === 1) {
              let newData = planData.filter((r) => r.id != row.id);
              setPlanData(newData);
              toast.success(row.name + " Deleted Successfully", {
                autoClose: 3000,
              });
            } else {
              toast.error(res.data.data || "Failed to delete plan", {
                autoClose: 3000,
              });
            }
            setLoading(false);
          },
          (error) => {
            setLoading(false);
            toast.error(
              error.response?.data?.message || "Something went wrong..",
              { autoClose: 3000 }
            );
          }
        );
      }
    });
  };

  useEffect(() => {
    getPlans();
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-6">
          <h1>
            Plans <small className="me-2">({planData.length})</small>
          </h1>
        </div>
        <div className="col-6">
          <div className="d-flex align-items-center justify-content-end">
            <Link to={"/settings/subscription/add"} className="btn btn-primary">
              <i className="fa fa-plus-circle me-2" aria-hidden="true"></i> Add
              Plan
            </Link>
          </div>
        </div>
        <div className="col-sm-12">
          <div className="card">
            <div className="card-body p-0">
              {loading && <Loader></Loader>}
              {!loading && (
                <div className="table-responsive">
                  <table className="table">
                    <thead className="">
                      <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Type</th>
                        <th>Price</th>
                        <th>Duration (days)</th>
                        <th>Description</th>
                        <th className="text-center" style={{ width: "200px" }}>
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {planData.length === 0 ? (
                        <tr>
                          <td colSpan="7" className="text-center">
                            No plans found
                          </td>
                        </tr>
                      ) : (
                        planData.map((row, key) => {
                          return (
                            <tr key={key}>
                              <td style={{ width: "30px" }}>{key + 1}</td>
                              <td>{row.name}</td>
                              <td>
                                <span className="badge bg-primary">
                                  {row.type}
                                </span>
                              </td>
                              <td>₹{row.price}</td>
                              <td>{row.duration}</td>
                              <td>
                                {row.description
                                  ? row.description.length > 50
                                    ? row.description.substring(0, 50) + "..."
                                    : row.description
                                  : "-"}
                              </td>
                              <td
                                className="d-flex justify-content-center gap-2"
                                style={{ width: "200px" }}
                              >
                                <Link
                                  to={"/settings/subscription/edit/" + row.id}
                                  className="btn btn-sm btn-secondary mr-2"
                                >
                                  <i className="fa fa-edit me-1"></i> Edit
                                </Link>
                                <button
                                  onClick={() => deletePlan(row)}
                                  className="btn btn-sm btn-danger"
                                >
                                  <i className="fa fa-trash me-1"></i> Delete
                                </button>
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Subscription;
